import React from "react";

// The learner count is in the pricing heading just below, so not here too.
const WhySection = () => (
  <>
    <section className="why-section" aria-labelledby="why-title">
      <div className="container">
        <div className="header">
          <h2 className="section-title" id="why-title">
            Why Learners Choose Us
          </h2>
          <p className="section-sub" style={{ margin: "8px auto 0" }}>
            We use the science of learning to make courses people actually
            finish.
          </p>
        </div>
        <div className="why-grid">
          <article className="why-card">
            <div className="step-num" aria-hidden="true">
              01
            </div>
            <div className="icon" aria-hidden="true">
              <svg>
                <use href="#icon-cert" />
              </svg>
            </div>
            <h3>80%+ Completion Rate</h3>
            <p>
              Industry average is 5–15%. We're not bragging. OK, maybe a little.
            </p>
          </article>
          <article className="why-card">
            <div className="step-num" aria-hidden="true">
              02
            </div>
            <div className="icon" aria-hidden="true">
              <svg>
                <use href="#icon-experts" />
              </svg>
            </div>
            <h3>World-Class Experts</h3>
            <p>
              Dan Ariely, Rory Sutherland, Sir John Hegarty &amp; co. The people
              who wrote the book. Literally.
            </p>
          </article>
          <article className="why-card">
            <div className="step-num" aria-hidden="true">
              03
            </div>
            <div className="icon" aria-hidden="true">
              <svg>
                <use href="#icon-ondemand" />
              </svg>
            </div>
            <h3>Human-Marked, Not Robot-Checked</h3>
            <p>
              Our learning team marks your work and gives feedback within 24
              hours. Real humans, not a tick-box quiz.
            </p>
          </article>
          <article className="why-card">
            <div className="step-num" aria-hidden="true">
              04
            </div>
            <div className="icon" aria-hidden="true">
              <svg>
                <use href="#icon-ai" />
              </svg>
            </div>
            <h3>Personalised to You</h3>
            <p>
              Every course adapts to your role, location and goals. Same expert
              content, tailored to you.
            </p>
          </article>
        </div>
      </div>
    </section>
    <svg style={{ display: "none" }} aria-hidden="true">
      <defs>
        <linearGradient id="gGold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F5B041" />
          <stop offset="100%" stopColor="#E59C2E" />
        </linearGradient>

        <g id="blob-1">
          <path d="M -20,-30 C -60,-30 -70,20 -40,50 C -10,70 50,60 70,30 C 85,5 50,-10 30,-5 C 10,0 0,-30 -20,-30 Z" />
          <path
            d="M 35,-45 C 30,-65 60,-65 65,-45 C 70,-25 40,-25 35,-45 Z"
            transform="translate(-10, 15)"
          />
        </g>

        <g id="blob-2">
          <path d="M -25,-25 C -65,-25 -70,25 -35,55 C -5,75 40,55 60,25 C 75,-5 45,-5 25,0 C 5,5 -5,-25 -25,-25 Z" />
          <path
            d="M 30,-50 C 25,-65 50,-70 55,-55 C 60,-40 35,-35 30,-50 Z"
            transform="translate(-10, 15)"
          />
        </g>

        <g id="blob-3">
          <path d="M -15,-35 C -55,-40 -80,10 -50,40 C -20,70 60,70 80,40 C 95,10 50,-15 30,-5 C 10,5 5,-30 -15,-35 Z" />
          <path
            d="M 25,-40 C 20,-60 50,-65 55,-45 C 60,-25 30,-20 25,-40 Z"
            transform="translate(-10, 15)"
          />
        </g>
      </defs>

      {/* CERT */}
      <symbol id="icon-cert" viewBox="0 0 48 56">
        <rect
          x="6"
          y="2"
          width="36"
          height="32"
          rx="3"
          fill="#F5B041"
          fillOpacity=".15"
          stroke="#C4841D"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <rect x="14" y="8" width="20" height="6" rx="1.5" fill="#C4841D" />
        <line
          x1="12"
          y1="20"
          x2="36"
          y2="20"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="16"
          y1="26"
          x2="32"
          y2="26"
          stroke="#C4841D"
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity=".5"
        />
        <path
          d="M18 46l-4 9 3-1.5 1.5 3 3-8"
          fill="#C4841D"
          fillOpacity=".6"
          stroke="#C4841D"
          strokeWidth="1"
          strokeLinejoin="round"
        />
        <path
          d="M30 46l4 9-3-1.5-1.5 3-3-8"
          fill="#C4841D"
          fillOpacity=".6"
          stroke="#C4841D"
          strokeWidth="1"
          strokeLinejoin="round"
        />
        <circle cx="24" cy="40" r="11" fill="#FAFAFE" />
        <circle
          cx="24"
          cy="40"
          r="9"
          fill="#F5B041"
          fillOpacity=".25"
          stroke="#C4841D"
          strokeWidth="2.5"
        />
        <circle
          cx="24"
          cy="40"
          r="5.5"
          fill="none"
          stroke="#C4841D"
          strokeWidth="1.5"
        />
        <path
          d="M21 40l2 2 4-4"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>

      {/* EXPERTS */}
      <symbol id="icon-experts" viewBox="0 0 48 48">
        <circle
          cx="24"
          cy="14"
          r="7"
          fill="#F5B041"
          fillOpacity=".12"
          stroke="#C4841D"
          strokeWidth="2.5"
        />
        <circle
          cx="13"
          cy="17"
          r="5.5"
          fill="#F5B041"
          fillOpacity=".12"
          stroke="#C4841D"
          strokeWidth="2.5"
        />
        <circle
          cx="35"
          cy="17"
          r="5.5"
          fill="#F5B041"
          fillOpacity=".12"
          stroke="#C4841D"
          strokeWidth="2.5"
        />
        <path
          d="M8 38c0-6 4-10 10-10h12c6 0 10 4 10 10"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M2 40c0-5 3-8 7-9"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
          opacity=".5"
        />
        <path
          d="M46 40c0-5-3-8-7-9"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
          opacity=".5"
        />
      </symbol>

      {/* ON DEMAND */}
      <symbol id="icon-ondemand" viewBox="0 0 48 48">
        <path
          d="M8 10h24a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H18l-8 6v-6H8a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4z"
          fill="#F5B041"
          fillOpacity=".15"
          stroke="#C4841D"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <path
          d="M14 20l4 4 8-8"
          fill="none"
          stroke="#C4841D"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="36" cy="34" r="8" fill="#FAFAFE" />
        <circle
          cx="36"
          cy="34"
          r="7"
          fill="#F5B041"
          fillOpacity=".2"
          stroke="#C4841D"
          strokeWidth="2.5"
        />
        <path
          d="M36 30v4l3 2"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>

      {/* AI */}
      <symbol id="icon-ai" viewBox="0 0 48 48">
        <path
          d="M22 10l3.5 10.5 10.5 3.5-10.5 3.5L22 38l-3.5-10.5L8 24l10.5-3.5z"
          fill="#C4841D"
          stroke="#C4841D"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </symbol>

      {/* SPARKLE */}
      <symbol id="icon-sparkle" viewBox="0 0 24 24">
        <path
          d="M10 8l1.5 5L16.5 14.5l-5 1.5L10 21l-1.5-5L3.5 14.5l5-1.5z"
          fill="#C4841D"
          stroke="#C4841D"
          strokeWidth=".5"
          strokeLinejoin="round"
        />
      </symbol>

      {/* GIFT */}
      <symbol id="icon-gift" viewBox="0 0 36 36">
        <rect
          x="5"
          y="18"
          width="26"
          height="14"
          rx="2"
          fill="#F5B041"
          fillOpacity=".12"
          stroke="#C4841D"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <rect
          x="3"
          y="12"
          width="30"
          height="7"
          rx="2"
          fill="#F5B041"
          fillOpacity=".12"
          stroke="#C4841D"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <line
          x1="18"
          y1="12"
          x2="18"
          y2="32"
          stroke="#C4841D"
          strokeWidth="2.5"
        />
      </symbol>
    </svg>
  </>
);
export default WhySection;
